import { OrderBy, SearchMatchMode } from "@/types";

export const DEFAULT_SORT: OrderBy = "asc";

export const DEFAULT_SEARCH_MATCH_MODE: SearchMatchMode = "starts_with";

export const SORT_OPTIONS = [
  { value: "asc", label: "Earliest Due Date" },
  { value: "desc", label: "Latest Due Date" },
] as const;

export const AVI_SORT_OPTIONS = [
  ...SORT_OPTIONS,
  { value: "code_asc", label: "AVI Code (Ascending)" },
  { value: "code_desc", label: "AVI Code (Descending)" },
] as const;

export const DEADLINE_OPTIONS = ["on_track", "near_deadline", "overdue"] as const;
export const DEADLINE_FILTER_OPTIONS = [
  "on_track",
  "near_deadline",
  "overdue",
  "completed",
] as const;
export const PROJECT_STATUS_FILTER_OPTIONS = [
  "assessment",
  "report",
  "signatures",
  "on_hold",
  "completed",
  "canceled",
] as const;

export * from "./assessment";
export * from "./aviPillars";
export * from "./aviStatus";
export * from "./evidence";
export * from "./issue";
export * from "./pagination";
export * from "./projectStatus";
export * from "./session";
export * from "./tagColors";
export * from "./upload";
